import { ApiType } from "@gymflow/common";
import { useMutation } from "@tanstack/react-query";

export function useMutationGetInvoice({ api }: { api: ApiType }) {
  return useMutation({
    mutationFn: async ({
      invoiceNumber,
    }: {
      invoiceNumber: string;
    }) => {
      return (
        await api.memberApi.getInvoiceByInvoiceNumber(invoiceNumber)
      ).data;
    },
  });
}
